import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Button } from "@shopify/polaris"
import { DragHandleIcon } from "@shopify/polaris-icons"
import classNames from "classnames"
import type { FC, ReactNode } from "react"
import { memo } from "react"

import styles from "./index.module.scss"

export interface CardProps {
  id: string;
  children: ReactNode
  outClassName?: string
  showHandle?: boolean
  disabled?: boolean
  dragHandleDisabled?: boolean
}

export const Card: FC<CardProps> = memo(function Card(props: CardProps) {
  const { children, outClassName, showHandle, disabled, dragHandleDisabled } = props
  const { setNodeRef, attributes, listeners, transform, transition } = useSortable({
    id: props.id,
    disabled: disabled,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div className={classNames(styles.cardWrapper, outClassName, disabled && styles.disabled)} ref={setNodeRef} style={style}>
      <div className={styles.container}>
        {children}
      </div>

      {
        disabled || dragHandleDisabled
          ? <div className={"flex"}>
            <Button variant={"tertiary"} disabled icon={DragHandleIcon}  />
          </div>
          : showHandle && <div className={"flex"} {...attributes} {...listeners}>
            <Button variant={"tertiary"} icon={DragHandleIcon}  />
          </div>
      }
    </div>
  )
})
